import React from 'react';
import { RouteType } from './types';
import { SitemapContainer } from '../../Pages/Sitemap/SitemapContainer';
import { SitemapLayout } from '../../Pages/Sitemap/SitemapLayout';
import { CVRoutes, MariamRoutes, IntuitRoutes } from './helpers';
import { PortfolioRoutes } from './helpers';
import { ComingSoonContainer } from '../../Pages/ComingSoon/ComingSoonContainer';
import { ComingSoonLayout } from '../../Pages/ComingSoon/ComingSoonLayout';
import { ShenizCanvasingContainer } from '../../Pages/ShenizCanvasing/ShenizCanvasingContainer';
import { ShenizCanvasingLayout } from '../../Pages/ShenizCanvasing/ShenizCanvasingLayout';
import { PaywallSniperContainer } from '../../Pages/PaywallSniper/PaywallSniperContainer';
import { PaywallSniperLayout } from '../../Pages/PaywallSniper/PaywallSniperLayout';

export const productionRoutes: Array<RouteType> = [
	{
		path: '/',
		element: <ComingSoonContainer Layout={ComingSoonLayout} />,
	},
	{
		path: '/sitemap',
		element: <SitemapContainer Layout={SitemapLayout} />,
	},
	{
		path: '/sheniz',
		element: <ShenizCanvasingContainer Layout={ShenizCanvasingLayout} />,
	},
	{
		path: '/sniper',
		element: <PaywallSniperContainer Layout={PaywallSniperLayout} />,
	},
	...IntuitRoutes,
	...MariamRoutes,
	...CVRoutes,
	...PortfolioRoutes,
];

export const routes = productionRoutes;
